<kt-base-modal [title]="'Task Group'">
  <div modal-body>
    <!-- Body content -->
    <div class="fix-body-height">
      <kt-textbox [field]="addTaskGroupControl.task_group_name" [form]="newTaskFormGroup">
      </kt-textbox>
      <div class="text-end mt-3">
        <button class="btn btn-brand btn-sm" (click)="addClickHandler()">Add New Sub-Task </button>
      </div>
      <ng-container *ngFor="let subTask of subTasks.controls;let i = index">
        <div class="row">
          <div class="col-8 form-group">
            <kt-textbox [field]="addTaskGroupControl.sub_task_name" [form]="subTask">
            </kt-textbox>
          </div>
          <div class="col-2 d-flex align-items-center" *ngIf="i != 0">
            <button (click)="removeTaskGroup(i)" class="btn btn-sm btn-clean btn-icon btn-icon-md">
              <svg-icon class="svg_icon13x13 d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/delete.svg"></svg-icon>
            </button>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Footer -->
    <div class="modal-footer d-flex justify-content-between kt-login__actions">
      <kt-button [buttonConfig]="buttonConfig.CLOSE_BUTTON_CONFIG" (buttonClick)="activeModal.close()">
      </kt-button>
      <kt-button [buttonConfig]="buttonConfig.SAVE_BUTTON_CONFIG" (buttonClick)="saveButtonClickHandler()">
      </kt-button>
    </div>

  </div>
</kt-base-modal>